'use strict';

angular.module('atex.dam').controller('DamMapPickerModalController', ['$scope','$translate',
  function($scope, $translate) {
    $scope.panelTitle = $translate.getTranslationTable().__GEO_LOCATION_DLG_TITLE__;
    $scope.loaded = false;
    $scope.showSpinner = true;
    $scope.maps = atex.Content();

    if($scope.queryModel.set[$scope.fieldName] !== undefined){
      $scope.queryModel.set[$scope.fieldName].forEach(function(pointCsv){
        var val = pointCsv.split(",");
        var point = {latitude: val[0], longitude: val[1], radius: val[2]};
        $scope.data.push(point);
      });
    }

    $scope.maps.data.aspects = {
      "contentData": {
        "data": {
          "_type": "atex.onecms.article",
          "locations": $scope.data
        }
      }
    };

    $scope.template = {
      "id": "dam.map.picker",
      "dataBindings": [
        {
          "name": "location",
          "widget": "pGoogleMapsPicker",
          "domainObjects": {
            "data": "contentData/locations"
          }
        }
      ]
    };

    $scope.loaded = true;

    $scope.hideSpinner = function () {
      $scope.showSpinner = false;
    };

    $scope.changeEndCallback = function (data) {
      $scope.data = data.aspects.contentData.data.locations;
      $scope.dirty = true;
      $scope.$digest();
      return;
    };

    $scope.doOK = function () {
      $scope.queryModel.set[$scope.fieldName]=[];
      $scope.data.forEach(function(point){
        var value = point.latitude + ',' + point.longitude + ',' + point.radius;
        $scope.queryModel.set[$scope.fieldName].push(value);
      });
      $scope.$parent.doSave();
    };

  }]);